import { AXNUIFormContentSlotContentTypes } from "@iddataweb/idw-common-ui/enums";
import { SelectOption } from "@idw-types/common";

export const CONTENT_SLOT_CONTENT_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "Predefined Form Help Text", value: AXNUIFormContentSlotContentTypes.USE_PREDEFINED_FORM_HELP_TEXT },
    { label: "Custom HTML & CSS", value: AXNUIFormContentSlotContentTypes.USE_HTML_CSS },
    { label: "Image", value: AXNUIFormContentSlotContentTypes.USE_IMAGE },
    { label: "Content Modal Link", value: AXNUIFormContentSlotContentTypes.USE_MODAL }
];

export const EXPLICIT_CONSENT_CONTENT_TYPE_OPTION: SelectOption = {
    label: "Explicit Consent",
    value: AXNUIFormContentSlotContentTypes.USE_EXPLICIT_CONSENT_INPUT
};